export function globalCss(source: Document = document): string {
  return Array.from(source.styleSheets)
    .map(sheet => {
      try {
        return Array.from(sheet.cssRules, rule => rule.cssText).join('\n');
      } catch {
        return '';
      }
    })
    .join('\n');
}

export function prepareViewportFrame(frame: HTMLIFrameElement): Document {
  const frameDocument = frame.contentDocument;
  if (!frameDocument.head.querySelector('style[data-global-css]')) {
    const style = frameDocument.createElement('style');
    style.setAttribute('data-global-css', '');
    style.textContent = globalCss();
    frameDocument.head.appendChild(style);
    frameDocument.body.className = `${document.body.className} cipo`;
    Object.assign(frameDocument.body.style, { margin: '0', fontFamily: getComputedStyle(document.body).fontFamily });
  }
  return frameDocument;
}

export function resizeViewportFrame(frame: HTMLIFrameElement, width: number): void {
  frame.style.width = `${width}px`;
  void frame.offsetWidth;
}
